import React from 'react';
import SimpleLayout from 'features/shared/layout/SimpleLayout';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UserSelect from 'features/admin/pages/UserSelect';
import Header from 'features/shared/layout/header/Header';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import AdministrationSection from 'features/admin/sections/AdministrationSection';
import AllCustomersSelect from 'features/admin/pages/AllCustomersSelect';
import CustomerAccounts from 'features/admin/pages/CustomerAccounts';
import CustomerAccountDetail from 'features/admin/pages/CustomerAccountDetail';
import GenerateAccounts from 'features/admin/pages/GenerateAccounts';
import ContractingsAdminPage from 'features/admin/pages/ContractingsAdminPage';
import ContractingDetailAdminPage from './pages/ContractingDetailAdminPage';
import ContractingAddPage from 'features/contracting/pages/ContractingAddPage';
import RequirementsAdminPage from 'features/admin/pages/RequirementsAdminPage';
import RequirementAdminDetailPage from 'features/admin/pages/RequirementAdminDetailPage';
import VersionPage from './pages/VersionPage';

interface Props {
  
}

const Administration = (props: Props) => {

  // translations
  const { t } = useTranslation(["shared\\moduleNames"]);

  let match = useRouteMatch();

  return (
    <SimpleLayout useSpinner>
      <Switch>
        <Route path={`${match.path}customers/:customerId/accounts/:accountId`} component={CustomerAccountDetail} />
        <Route path={`${match.path}customers/:customerId/accounts`} component={CustomerAccounts} />
        <Route path={`${match.path}customers`} component={AllCustomersSelect} />
        <Route path={`${match.path}user-select`} component={UserSelect} />
        <Route path={`${match.path}generate-accounts`} component={GenerateAccounts} />
        <Route path={`${match.path}contracting/add`} component={ContractingAddPage} />
        <Route path={`${match.path}admin/contractings/:contractingId`} component={ContractingDetailAdminPage} />
        <Route path={`${match.path}admin/contractings`} component={ContractingsAdminPage} />
        <Route path={`${match.path}admin/email-requirements/:requirementId`} component={RequirementAdminDetailPage} />
        <Route path={`${match.path}admin/email-requirements`} component={RequirementsAdminPage} />
        <Route path={`${match.path}version`} component={VersionPage} />
        <Route exact path={`${match.path}`}>
          <Header title={t("administration.title")} />
          <ModuleContent>
            <AdministrationSection />
          </ModuleContent>
        </Route>
        <Redirect to="/" />
      </Switch>
    </SimpleLayout>
  )
}

export default Administration;
